import { Main } from "../components/bank-accounts-inquiry/Main";
import { useAuthenticationHook } from "../app/useAuthenticationHook";
import { PERMISSIONS } from "../configs/constants";
import { createContext, useEffect, useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useGetBankAccountsReferenceQuery } from "../features/api";
import { BankAccountsReferenceResponse } from "../features/api-interfaces";

interface IBankAccountInquiryContext {
  companyContractBankAccountNo: number;
  apiResponse?: BankAccountsReferenceResponse;
  isFetching: boolean;
}

export const BankAccountInquiryContext =
  createContext<IBankAccountInquiryContext | null>(null);

/**
 * 入金口座情報照会
 */
const BankAccountInquiry = () => {
  const { pathname } = useLocation();
  const hasAuthority = useAuthenticationHook(PERMISSIONS.APPLY_COMPANY_READ);
  const { companyContractBankAccountNo } = useParams();
  const {
    data: apiResponse,
    isFetching,
    refetch,
  } = useGetBankAccountsReferenceQuery(companyContractBankAccountNo!);

  useEffect(() => {
    refetch();
  }, [refetch, pathname]);

  const contextValue: IBankAccountInquiryContext = useMemo(
    () => ({
      companyContractBankAccountNo: companyContractBankAccountNo
        ? Number(companyContractBankAccountNo)
        : 0,
      apiResponse,
      isFetching,
    }),
    [companyContractBankAccountNo, apiResponse, isFetching]
  );

  return (
    <BankAccountInquiryContext.Provider value={contextValue}>
      {hasAuthority && <Main />}
    </BankAccountInquiryContext.Provider>
  );
};

export default BankAccountInquiry;
